<template>
  <div class="card-container">
    <common-top-form
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      :show="false"
      :batchShow="true"
      batchName="批量同意"
      @batchLookDialog="batch(1)"
      batchShowType="warning"
    >
      <select-organs v-model="formModel.simpleTatId"></select-organs>
      <el-form-item label="订单号">
        <el-input
          type="text"
          maxlength="20"
          v-model="formModel.orderNo"
          placeholder="请输入订单号"
        ></el-input>
      </el-form-item>
      <el-form-item label="批次号">
        <el-input
          type="text"
          maxlength="20"
          v-model="formModel.batchNo"
          placeholder="请输入批次号"
        ></el-input>
      </el-form-item>
      <el-form-item label="手机号">
        <el-input
          v-model="formModel.phone"
          maxlength="50"
          placeholder="请输入手机号"
        ></el-input>
      </el-form-item>
      <el-form-item label="通道编码">
        <el-input
          v-model="formModel.chnCode"
          maxlength="50"
          placeholder="请输入通道编码"
        ></el-input>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-select v-model="formModel.status">
          <el-option
            v-for="item in status"
            :key="item.id"
            :label="item.value"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="创建时间">
        <el-date-picker
          v-model="time"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
    </common-top-form>
    <common-table
      :data="tableData"
      ref="commonTable"
      @handleChange="getPage"
      @handleSelectionChange="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        :selectable="checkboxT"
        disabled="true"
        width="60"
        margin-left="5px"
      >
      </el-table-column>
      <el-table-column
        prop="tatId"
        label="机构简称"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="batchNo"
        label="批次号"
        min-width="210"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="orderNo"
        label="订单号"
        min-width="280"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="amount"
        label="金额"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="type"
        label="提现类型"
        min-width="150"
        :formatter="formatterTableDataType"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="chnCode"
        label="通道编码"
        min-width="210"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="phone"
        label="手机号"
        min-width="210"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="cardNo"
        label="卡号"
        min-width="210"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="userName"
        label="姓名"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="idCard"
        label="身份证"
        min-width="210"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        :formatter="formatterTableDataStatus"
        min-width="150"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="resMsg"
        label="响应信息"
        :formatter="formatterTableData"
        min-width="210"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        min-width="160"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="操作" min-width="160">
        <template slot-scope="scope">
          <div v-if="scope.row.status == 0">
            <el-button type="text" @click="handleStatus(scope.row, 1)"
              >同意</el-button
            >
            <el-button type="text" @click="handleStatus(scope.row, 0)"
              >驳回</el-button
            >
          </div>
          <div v-else>已操作!</div>
        </template>
      </el-table-column>
    </common-table>
    <!-- <form-dialog
      ref="formDialog"
      formDialogTitle="编辑"
      :model="dialogModel"
      :submitData="dialogData"
      :dialogService="dialogService"
      @close="dialogClose"
      @success="dialogSuccess"
      labelWidth="110px"
      class="note"
    >
      <el-form-item label="机构名称" prop="tatName">
        <el-input
          type="text"
          maxlength="20"
          v-model="dialogModel.tatName"
          :disabled="true"
        ></el-input>
      </el-form-item>
      <el-form-item label="订单号" prop="id">
        <el-input
          type="text"
          maxlength="20"
          v-model="dialogModel.id"
          :disabled="true"
        ></el-input>
      </el-form-item>
      <el-form-item label="电话号码" prop="phoneNumber">
        <el-input
          type="text"
          maxlength="20"
          v-model="dialogModel.phoneNumber"
          :disabled="true"
        ></el-input>
      </el-form-item>
      <el-form-item label="会员名称" prop="realName">
        <el-input
          type="text"
          maxlength="20"
          v-model="dialogModel.realName"
          :disabled="true"
        ></el-input>
      </el-form-item>
      <el-form-item label="订单状态" prop="status">
        <el-select v-model="dialogModel.status">
          <el-option
            v-for="item in status"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="快递公司" prop="expressCom">
        <el-select v-model="dialogModel.expressCom">
          <el-option
            v-for="item in ExpressTypes"
            :key="item.expressCom"
            :label="item.expressName"
            :value="item.expressCom"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="单号" prop="expressNo">
        <el-input
          type="text"
          maxlength="100"
          v-model="dialogModel.expressNo"
          placeholder="请输入单号"
        ></el-input>
      </el-form-item>
      <el-form-item label="收货人姓名" prop="userName">
        <el-input
          type="text"
          maxlength="20"
          v-model="dialogModel.userName"
          placeholder="请输入收货人姓名"
        ></el-input>
      </el-form-item>
      <el-form-item label="收货人手机号" prop="userPhone">
        <el-input
          type="text"
          maxlength="20"
          v-model="dialogModel.userPhone"
          placeholder="请输入收货人手机号"
        ></el-input>
      </el-form-item>
      <el-form-item label="收货地址" prop="address">
        <el-input
          type="text"
          maxlength="255"
          v-model="dialogModel.address"
          placeholder="请输入收货地址"
        ></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input
          v-model="dialogModel.remark"
          maxlength="80"
          show-word-limit
          type="textarea"
          resize="none"
          rows="5"
        ></el-input>
      </el-form-item>
    </form-dialog> -->
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import SelectOrgans from "components/business/SelectOrgans";
import FormDialog from "../../dialog/FormDialog";

import MallService from "service/MallService";
import TimeRange from "service/constant/TimeRange";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "connectwithdrawalreview",
  components: {
    CommonTopForm,
    CommonTable,
    SelectOrgans,
    FormDialog,
  },
  data() {
    return {
      formModel: {
        simpleTatId: "",
        orderNo: "",
        batchNo: "",
        phone: "",
        chnCode: "",
        status: "",
      },
      tableData: [],
      batchdata: [],
      multipleSelection: [],
      submitService: MallService.connectwithdrawalreviewList,
      time: TimeRange.monthRange,
      status: [
        {
          id: "",
          value: "全部",
        },
        {
          id: "0",
          value: "待审核",
        },
        {
          id: "1",
          value: "审核中",
        },
        {
          id: "2",
          value: "成功",
        },
        {
          id: "3",
          value: "驳回",
        },
      ],
      page: {},
      isPage: false,
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.load();
  },
  computed: {
    submitData() {
      if (this.time == null || this.time == "") {
        this.time = [];
      }
      this.params = {
        simpleTatId: this.formModel.simpleTatId,
        orderNo: this.formModel.orderNo,
        batchNo: this.formModel.batchNo,
        phone: this.formModel.phone,
        chnCode: this.formModel.chnCode,
        status: this.formModel.status,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      if (this.time.length) {
        this.params.beginDate = this.time[0];
        this.params.endDate = this.time[1];
      }
      return this.params;
    },
    dialogData() {},
    ...mapGetters(["serverType", "tatId", "userId", "orgDetail"]),
  },
  watch: {},
  methods: {
    load() {
      this.formModel = {
        tatId: "",
        status: "",
      };
      this.page = this.$refs.commonTable.page;
      this.getList();
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    handleStatus(item, flag) {
      this.showConfirm("是否执行该操作？")
        .then(() => {
          this.doStatus(item.id, flag);
        })
        .catch(() => {});
    },
    doStatus(id, flag) {
      this.doLoad(
        MallService.connectwithdrawalreviewCheck,
        {
          applyIdStr: id,
          operate: flag,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.commonSuccess(res);
          });
        },
        "操作失败"
      );
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;
        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getList();
      if (res.respCode == "0000") {
        const https = res.respMsg;
        const ifUrl =
          /^(((ht|f)tps?):\/\/)?([^!@#$%^&*?.\s-]([^!@#$%^&*?.\s]{0,63}[^!@#$%^&*?.\s])?\.)+[a-z]{2,6}\/?/;

        const ifHttps = ifUrl.test(https);
        if (ifHttps == true) {
          window.open(https, "_blank");
        } else {
          return;
        }
      } else {
        return;
      }
    },
    openAddDialog(item) {
      this.dialogModel = JSON.parse(JSON.stringify(item));
      this.dialogModel.remark = this.dialogModel.remark
        ? this.dialogModel.remark
        : "";
      this.$refs.formDialog.open();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      let str = "";
      this.multipleSelection.forEach(function (item, index) {
        str += item.id + ",";
      });
      str = str.substring(0, str.length - 1);
      this.batchdata = str.split(",");
    },
    batch(flag) {
      this.showConfirm("是否执行该操作？")
        .then(() => {
          this.doLoad(
            MallService.connectwithdrawalreviewCheck,
            {
              applyIdStr: this.batchdata,
              operate: flag,
            },
            (res) => {
              this.doCheck(res, (res) => {
                // this.showSuccess(res.respMsg);
                this.commonSuccess(res);
                this.getList();
              });
            },
            "信息获取失败"
          );
        })
        .catch(() => {});
    },
    checkboxT(row, index) {
      if (row.status == 0) {
        return true;
      } else {
        return false;
      }
    },
    // dialogSuccess(res) {
    //   this.showSuccess(res.respMsg);
    //   this.$refs.formDialog.closeDialog();
    //   this.getList();
    // },
    // dialogClose() {
    //   this.dialogModel = {};
    // },
    formatterTableDataType: function (row, column, cellValue) {
      switch (row.type) {
        case "0":
          return "机构";
          break;
        case "1":
          return "会员";
          break;
        default:
          return "--";
      }
    },
    formatterTableDataStatus: function (row, column, cellValue) {
      switch (row.status) {
        case 0:
          return "待审核";
          break;
        case 1:
          return "审核中";
          break;
        case 2:
          return "成功";
          break;
        case 3:
          return "驳回";
          break;
        default:
          return "--";
      }
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/FinanceManage/ConnectWithdrawalReview.vue